import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "./baseSlice";
import intl from "../../i18n/intl";
import { toast } from "react-toastify";

const initialState = {
  session: null,
  requesting: false,
  error: null,
  action: null,
};

const customIntl = intl();

const authSlice = createSlice({
  name: "auth",
  initialState,
  extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
  reducers: {
    resetState: (state, action) => {
      state.requesting = false;
      state.error = null;
      state.action = null;
    },
    sessionRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "sign-in";
    },
    sessionSuccess: (state, action) => {
      state.session = {
        accessToken:
          action.payload.response.accessToken || state.session?.accessToken,
        refreshToken:
          action.payload.response.refreshToken || state.session?.refreshToken,
      };
      state.requesting = false;
      state.error = null;
    },
    sessionFail: (state, action) => {
      state.session = null;
      state.requesting = false;
      state.error = action.payload;
    },
    sendResetPasswordInstructionsRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "forgot-password";
    },
    sendResetPasswordInstructionsSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
    },
    sendResetPasswordInstructionsFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
    },
    resetPasswordRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "reset-password";
    },
    resetPasswordSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
    },
    resetPasswordFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
    },
    logout: (state, action) => {
      state.error = null;
      state.action = "logout";
    },
    refreshTokenRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "refresh";
    },
    otpRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "otp-request";
    },
    otpSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      state.session = {
        accessToken:
          action.payload?.response?.accessToken || state.session?.accessToken,
      };
      toast.success(customIntl.formatMessage({ id: "otp_sent_successfully" }));
    },
    otpFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
    },
    resendOTPRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "otp-request";
    },
    resendOTPSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage({ id: "otp_resent_successfully" })
      );
    },
    resendOTPFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
    },
    verifyOTPRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "verify-otp";
    },
    verifyOTPSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      state.session = {
        accessToken:
          action.payload.response.accessToken || state.session?.accessToken,
        refreshToken:
          action.payload.response.refreshToken || state.session?.refreshToken,
      };
    },
    verifyOTPFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
    },
  },
});

export const {
  logout,
  refreshTokenRequest,
  resetPasswordFail,
  resetPasswordRequest,
  resetPasswordSuccess,
  resetState,
  sendResetPasswordInstructionsFail,
  sendResetPasswordInstructionsRequest,
  sendResetPasswordInstructionsSuccess,
  sessionFail,
  sessionRequest,
  sessionSuccess,
  otpRequest,
  otpSuccess,
  otpFail,
  resendOTPRequest,
  resendOTPSuccess,
  resendOTPFail,
  verifyOTPRequest,
  verifyOTPSuccess,
  verifyOTPFail,
} = authSlice.actions;
export default authSlice.reducer;
